import { directSocketSave } from '@/views/editor/composable/useSocketSave'
import { UseHistory } from '@/views/editor/composable/useHistory.ts'

const TITLE_CLASS = 'image--caption__title'
const DESC_CLASS = 'image--caption__description'

export function useImageCaption() {
	/**
	 * 캡션 토글: 이미 있으면 제거, 없으면 추가
	 */
	function toggle(block: HTMLElement) {
		const hasCaption = block.querySelector(`.${TITLE_CLASS}`) || block.querySelector(`.${DESC_CLASS}`)
		if (hasCaption) {
			removeCaption(block)
		} else {
			addCaption(block)
		}
	}

	/**
	 * 이미지 블록에 title / description 캡션 추가
	 */
	function addCaption(block: HTMLElement) {
		const imageContainer = block.querySelector('.image--container') as HTMLDivElement
		if (!imageContainer) return

		const titleEl = createCaptionElement(TITLE_CLASS, '제목을 입력하세요')
		const descEl = createCaptionElement(DESC_CLASS, '설명을 입력하세요')

		imageContainer.before(titleEl)
		imageContainer.after(descEl)

		bindCaptionEvents(block, titleEl)
		bindCaptionEvents(block, descEl)

		titleEl.focus()
		saveBlock(block)
	}

	/**
	 * 캡션 제거
	 */
	function removeCaption(block: HTMLElement) {
		block.querySelector(`.${TITLE_CLASS}`)?.remove()
		block.querySelector(`.${DESC_CLASS}`)?.remove()
		saveBlock(block)
	}

	/**
	 * contenteditable 캡션 요소 생성
	 */
	function createCaptionElement(className: string, placeholder: string): HTMLDivElement {
		const el = document.createElement('div')
		el.className = className
		el.setAttribute('contenteditable', 'true')
		el.setAttribute('data-placeholder', placeholder)
		return el
	}

	/**
	 * 캡션 요소에 이벤트 바인딩 (입력 시 저장, 엔터 시 줄바꿈 방지)
	 */
	function bindCaptionEvents(block: HTMLElement, captionEl: HTMLDivElement) {
		captionEl.addEventListener('input', () => {
			saveBlock(block)
		})

		captionEl.addEventListener('keydown', (e: KeyboardEvent) => {
			if (e.key === 'Enter') {
				e.preventDefault()
			}
		})

		captionEl.addEventListener('focus', (e: FocusEvent) => {
			e.stopPropagation()
		})

		captionEl.addEventListener('mousedown', (e: MouseEvent) => {
			e.stopPropagation()
		})

		captionEl.addEventListener('click', (e: MouseEvent) => {
			e.stopPropagation()
		})
	}

	/**
	 * 블록 저장 후 히스토리 push
	 */
	async function saveBlock(block: HTMLElement) {
		await directSocketSave('image', block)
		new UseHistory().push()
	}

	/**
	 * 로드 시 기존 캡션 요소에 이벤트 재바인딩
	 */
	function rebindCaptionEvents(block: HTMLElement) {
		const titleEl = block.querySelector(`.${TITLE_CLASS}`) as HTMLDivElement
		const descEl = block.querySelector(`.${DESC_CLASS}`) as HTMLDivElement

		if (titleEl) {
			titleEl.setAttribute('contenteditable', 'true')
			bindCaptionEvents(block, titleEl)
		}
		if (descEl) {
			descEl.setAttribute('contenteditable', 'true')
			bindCaptionEvents(block, descEl)
		}
	}

	return {
		toggle,
		addCaption,
		removeCaption,
		rebindCaptionEvents,
	}
}
